// https://gist.github.com/rendro/525bbbf85e84fa9042c2
export default function cookieToJSON (string) {
  if (typeof string === 'undefined') { return false }
  return string.split(';').reduce((res, c) => {
    const [key, val] = c
      .trim()
      .split('=')
      .map(decodeURIComponent)
    try {
      return Object.assign(res, { [key]: JSON.parse(val) })
    } catch (e) {
      return Object.assign(res, { [key]: val })
    }
  }, {})
}
